import { createFileRoute } from '@tanstack/react-router';

import { SectionIndex } from '@/features/app-shell/components/SectionLayout';
import { AI_USAGE_TABS } from '@/features/app-shell/navigation';

export const Route = createFileRoute('/workspaces/$workspaceId/ai-usage/')({
  component: AiUsageIndexRoute,
});

export function AiUsageIndexRoute() {
  const { workspaceId } = Route.useParams();
  return <SectionIndex tabs={AI_USAGE_TABS} workspaceId={workspaceId} />;
}
